import React from "react";

export default function Notes({ text }) {
  return (
    <div>
      <div className="row">
        <div className="col-1" />
        <div className="col-10">
          <table width="100%">
            <tbody>
              <tr className="table-primary">
                <td className="border border-dark m-2">
                  <strong>Note: </strong>
                  <span>{text}</span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className="col-1" />
      </div>
    </div>
  );
}
